import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { STATUS_STYLES } from "@/lib/format";

export const STATUS_OPTIONS = ["New", "In Progress", "Delivered", "Invoiced"];
const DOT = { New: "bg-slate-400", "In Progress": "bg-blue-500", Delivered: "bg-emerald-500", Invoiced: "bg-indigo-500" };

export const StatusSelect = ({ value, onChange, onOpenChange, testId }) => (
  <Select value={value} onValueChange={(v) => v !== value && onChange(v)} onOpenChange={onOpenChange}>
    <SelectTrigger className={`h-8 w-[132px] rounded-full px-3 text-xs font-medium shadow-none focus:ring-2 focus:ring-offset-1 ${STATUS_STYLES[value]}`} data-testid={testId}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {STATUS_OPTIONS.map((s) => (
        <SelectItem key={s} value={s} data-testid={`${testId}-option-${s.toLowerCase().replace(" ", "-")}`}>
          <span className="inline-flex items-center gap-2"><span className={`w-2 h-2 rounded-full ${DOT[s]}`} />{s}</span>
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
